/**
 * Http methods constants
 */
const httpMethods = {GET: "GET", POST: "POST", PATCH: "PATCH", PUT: "PUT", DELETE: "DELETE"}

export default httpMethods
